import React from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu/Menu';
import MyHead from '../../components/MyHead';
import { classNames } from '../../helpers/classes';
import localizedRoute from '../../utils/localizedRoute';
import Link from 'next/link';

const ImprintPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <MyHead />
      <Menu />
      <div
        className="h-500 flex justify-center items-end py-3"
        style={{
          background: `linear-gradient(to bottom, rgba(0, 20, 26, 0.1), rgba(0, 20, 26, 0.25)), url("../../img/general-page-img.jpg")`
        }}
      >
        <h1 className="font-sans text-8xl sm:text-9xl text-white uppercase">
          {t('IMPRINT_TITLE')}
        </h1>
      </div>
      <div className="flex items-stretch flex-col py-20 max-w-4xl mx-auto px-4 sm:px-0">
        <p className="font-bold mb-6">{t('IMPRINT_INTRO')}</p>
        <p
          className="mb-5"
          dangerouslySetInnerHTML={{ __html: t('IMPRINT_DESCRIPTION') }}
        />
        <Link className="text-primary" href={localizedRoute('/contacts')}>
          {t('CONTACTS')} - {t('CONTACT_US_PRIVATE')}
        </Link>
        <Link className="text-primary" href={localizedRoute('/b2bcontacts')}>
          {t('CONTACTS')} - {t('CONTACT_US_B2B')}
        </Link>
      </div>

      <Footer />
    </div>
  );
};

export default ImprintPage;
